// react_frontend/src/Components/Modules/Accounting/APAging.js
import React, { useState, useEffect } from 'react';
import { AxiosAuthInstance } from '../../../AxiosInterceptors';
import Breadcrumb from '../../Partials/Breadcrumb';
import {
    Box, Typography, Paper, TextField, Button, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow
} from '@mui/material';
import { FaSearch } from 'react-icons/fa';

export default function APAging() {
    const [aging, setAging] = useState([]);
    const [asOfDate, setAsOfDate] = useState('');

    const fetchAPAging = async () => {
        try {
            const res = await AxiosAuthInstance.get('accounting/reports/ap-aging', {
                params: { as_of_date: asOfDate }
            });
            setAging(res.data.aging || []);
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => { fetchAPAging(); }, []);

    return (
        <Box sx={{ p: 3, bgcolor: '#f5f7fa', minHeight: '100vh' }}>
            <Breadcrumb title="AP Aging" />
            <Paper sx={{ p: 3, mb: 3 }}>
                <Typography variant="h5" fontWeight={700} mb={2}>Accounts Payable Aging</Typography>
                <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
                    <TextField label="As of Date" type="date" value={asOfDate} onChange={(e) => setAsOfDate(e.target.value)} size="small" InputLabelProps={{ shrink: true }} />
                    <Button variant="contained" onClick={fetchAPAging} startIcon={<FaSearch />}>Generate</Button>
                </Box>

                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow sx={{ bgcolor: '#f8f9fa' }}>
                                <TableCell>Vendor</TableCell>
                                <TableCell align="right">Current (0-30)</TableCell>
                                <TableCell align="right">31-60 Days</TableCell>
                                <TableCell align="right">61-90 Days</TableCell>
                                <TableCell align="right">90+ Days</TableCell>
                                <TableCell align="right">Total</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {aging.map((row, idx) => (
                                <TableRow key={idx}>
                                    <TableCell><Typography fontWeight={600}>{row.vendor_name}</Typography></TableCell>
                                    <TableCell align="right">৳{Number(row.current).toLocaleString()}</TableCell>
                                    <TableCell align="right">{Number(row['31_60']).toLocaleString()}</TableCell>
                                    <TableCell align="right">৳{Number(row['61_90']).toLocaleString()}</TableCell>
                                    <TableCell align="right">৳{Number(row['90_plus']).toLocaleString()}</TableCell>
                                    <TableCell align="right" sx={{ fontWeight: 700 }}>৳{Number(row.total).toLocaleString()}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
        </Box>
    );
}